import { showPromoPeriodInMs, startOfPromoInMs } from './constants';

export function isPromoEnded() {
  const currentTimeInMs = Date.now();
  const promoEndInMs = startOfPromoInMs + showPromoPeriodInMs;
  return currentTimeInMs > promoEndInMs;
}
